import { AlertTypes } from '../plugins/alerts_types'
import { alert, notification } from '../plugins/helpers'

export default {
  methods: {
    proximaHoraCheia () {
      let data = new Date()
      data.setMinutes(0)
      data.setSeconds(0)
      data.setMilliseconds(0)
      data.setHours(data.getHours() + 1)
      return data.getHours()
    },
    showDialogReenviaContrato (id_contrato, telefone_assinante, exibe_reenvio_whatsapp, multiplas_cotas = false) {
      const sucessoMensagem = multiplas_cotas
        ? 'Contratos reenviados com sucesso!'
        : 'Contrato reenviado com sucesso!'
      const erroMensagem = multiplas_cotas
        ? 'Não foi possível reenviar os contratos'
        : 'Não foi possível reenviar o contrato'
      const mensagemEmail = multiplas_cotas
        ? 'Deseja reenviar os contratos para assinatura via e-mail?'
        : 'Deseja reenviar o contrato para assinatura via e-mail?'
      const mensagemChoiceSignature = multiplas_cotas
        ? 'Como deseja reenviar os contratos para assinatura?'
        : 'Como deseja reenviar o contrato para assinatura?'

      if (!exibe_reenvio_whatsapp) {
        alert({
          text: mensagemEmail,
          showCloseButton: true,
          buttons: {
            'Fechar': () => true,
            'Sim': async () => {
              try {
                await this.$http.post(`/contrato/reenviar/${id_contrato}`)
                notification(AlertTypes.SUCCESS, sucessoMensagem)
              } catch (e) {
                notification(AlertTypes.ERROR, e, erroMensagem)
              }
            }
          }
        })
      } else {
        alert({
          text: mensagemChoiceSignature,
          showCloseButton: true,
          buttons: {
            'E-mail': async () => {
              try {
                await this.$http.post(`/contrato/reenviar/${id_contrato}`)
                notification(AlertTypes.SUCCESS, sucessoMensagem)
              } catch (e) {
                notification(AlertTypes.ERROR, e, erroMensagem)
              }
            },
            'WhatsApp': async () => {
              try {
                await this.$http.post(`/contrato/reenviar-whatsapp/${id_contrato}`).then(result => {
                  const mensagemWhatsApp = multiplas_cotas
                    ? 'Os contratos serão enviados via WhatsApp.'
                    : 'O contrato será enviado via WhatsApp.'
                  notification(AlertTypes.INFO, mensagemWhatsApp)
                }).catch(e => {
                  if (e.response && e.response.status === 400) {
                    const mensagemErro = e.response.data && e.response.data.Msg_Erro
                      ? e.response.data.Msg_Erro
                      : 'Erro ao reenviar contrato via WhatsApp'
                    notification(AlertTypes.WARN, mensagemErro)
                    return true
                  }
                  notification(AlertTypes.ERROR, e, erroMensagem)
                })
              } catch (e) {
                notification(AlertTypes.ERROR, erroMensagem)
              }
            }
          }
        })
      }
    }
  }
}
